module.exports = __webpack_public_path__ + "static/media/menuLogoBanesco.ed56aa11.svg";